(function () {
  const REVEAL_MS = 1100;
  const EASE = "cubic-bezier(0.65, 0, 0.35, 1)";
  const SWIPE_THRESHOLD = 40;
  const CLICK_SUPPRESS_MS = 700;
  const WHEEL_THRESHOLD = 60;
  const WHEEL_LOCK_MS = 700;
  const WHEEL_IDLE_MS = 250;

  const direction = (prevIndex, nextIndex, total, loop) => {
    if (loop && total > 1) {
      if (prevIndex === total - 1 && nextIndex === 0) return "next";
      if (prevIndex === 0 && nextIndex === total - 1) return "prev";
    }
    return nextIndex > prevIndex ? "next" : "prev";
  };

  // Fade stacks every quote in one place, so links in the hidden ones stay out of the tab order
  const syncTextInert = (swiper) => {
    swiper.slides.forEach((slide, index) => {
      slide.inert = index !== swiper.activeIndex;
    });
  };

  // The media items are stacked, so only the shown one keeps its product link
  // in the tab order.
  const syncMediaInert = (items) => {
    items.forEach((item) => {
      item.inert = !item.classList.contains("is-active");
    });
  };

  const revealMedia = (items, nextIndex, prevIndex, dir) => {
    const incoming = items[nextIndex];
    const outgoing = prevIndex === nextIndex ? null : items[prevIndex];
    if (!incoming) return;

    const startClip =
      dir === "prev" ? "inset(0 100% 0 0)" : "inset(0 0 0 100%)";

    items.forEach((item) => item.classList.remove("is-active", "is-leaving"));

    incoming.style.transition = "none";
    incoming.style.clipPath = startClip;
    void incoming.offsetWidth;

    incoming.classList.add("is-active");
    incoming.style.transition = `clip-path ${REVEAL_MS}ms ${EASE}`;
    incoming.style.clipPath = "inset(0 0 0 0)";

    if (outgoing) {
      outgoing.classList.add("is-leaving");
      outgoing.style.transition = "none";
      outgoing.style.clipPath = "inset(0 0 0 0)";
    }
    syncMediaInert(items);
  };

  const showMediaImmediately = (items, index) => {
    items.forEach((item, i) => {
      item.classList.remove("is-active", "is-leaving");
      item.style.transition = "none";
      item.style.clipPath =
        i === index ? "inset(0 0 0 0)" : "inset(0 0 0 100%)";
    });
    if (items[index]) items[index].classList.add("is-active");
    syncMediaInert(items);
  };

  const resetMedia = (root, items) => {
    if (root) root.classList.remove("is-initialized");
    items.forEach((item) => {
      item.classList.remove("is-active", "is-leaving");
      item.style.transition = "";
      item.style.clipPath = "";
      item.inert = false;
    });
  };

  const unbindAutoplayHold = (root) => {
    if (!root?._testimonialsHold) return;
    root._testimonialsHold.destroy();
    root._testimonialsHold = null;
  };

  const bindContentSwipe = (root, swiper) => {
    const area = root.querySelector(".testimonials__content");
    if (!area) return;

    const controller = new AbortController();
    root._testimonialsSwipeController = controller;
    const opts = { signal: controller.signal };

    let startX = 0;
    let startY = 0;
    let tracking = false;
    let swipedAt = 0;

    area.addEventListener(
      "pointerdown",
      (event) => {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        if (event.target.closest(".js-testimonials-swiper")) return;
        tracking = true;
        swipedAt = 0;
        startX = event.clientX;
        startY = event.clientY;
      },
      opts
    );

    area.addEventListener(
      "pointerup",
      (event) => {
        if (!tracking) return;
        tracking = false;
        if (swiper.destroyed) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;
        if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

        swipedAt = event.timeStamp;
        const forward = swiper.rtlTranslate ? deltaX > 0 : deltaX < 0;
        if (forward) swiper.slideNext();
        else swiper.slidePrev();
      },
      opts
    );

    area.addEventListener(
      "pointercancel",
      () => {
        tracking = false;
      },
      opts
    );

    area.addEventListener(
      "click",
      (event) => {
        if (!swipedAt || event.timeStamp - swipedAt > CLICK_SUPPRESS_MS) return;
        swipedAt = 0;
        event.preventDefault();
        event.stopPropagation();
      },
      { ...opts, capture: true }
    );
  };

  const unbindContentSwipe = (root) => {
    if (!root?._testimonialsSwipeController) return;
    root._testimonialsSwipeController.abort();
    root._testimonialsSwipeController = null;
  };

  const bindWheelNav = (root, swiper) => {
    const area = root.querySelector(".testimonials__content");
    if (!area) return;

    const controller = new AbortController();
    root._testimonialsWheelController = controller;

    let accumulated = 0;
    let lastAt = 0;
    let lockedUntil = 0;

    area.addEventListener(
      "wheel",
      (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        if (swiper.destroyed) return;

        event.preventDefault();

        const now = event.timeStamp;
        if (now - lastAt > WHEEL_IDLE_MS) accumulated = 0;
        lastAt = now;
        if (now < lockedUntil) return;

        accumulated += event.deltaX;
        if (Math.abs(accumulated) < WHEEL_THRESHOLD) return;

        const forward = swiper.rtlTranslate
          ? accumulated < 0
          : accumulated > 0;
        if (forward) swiper.slideNext();
        else swiper.slidePrev();

        accumulated = 0;
        lockedUntil = now + WHEEL_LOCK_MS;
      },
      { signal: controller.signal, passive: false }
    );
  };

  const unbindWheelNav = (root) => {
    if (!root?._testimonialsWheelController) return;
    root._testimonialsWheelController.abort();
    root._testimonialsWheelController = null;
  };

  const destroySection = (section) => {
    if (!section || !section.classList?.contains("testimonials-section"))
      return;

    section.querySelectorAll(".testimonials").forEach((root) => {
      unbindAutoplayHold(root);
      unbindContentSwipe(root);
      unbindWheelNav(root);

      const sliderEl = root.querySelector(".js-testimonials-swiper");
      if (sliderEl?.swiper) sliderEl.swiper.destroy(true, true);

      const mediaRoot = root.querySelector(".testimonials__media");
      const items = Array.from(
        root.querySelectorAll(".testimonials-media__item")
      );
      resetMedia(mediaRoot, items);
    });
  };

  const initSection = (section) => {
    if (!section || !section.classList?.contains("testimonials-section"))
      return;

    const root = section.querySelector(".testimonials");
    if (!root) return;

    const mediaRoot = root.querySelector(".testimonials__media");
    const mediaItems = Array.from(
      root.querySelectorAll(".testimonials-media__item")
    );
    const sliderEl = root.querySelector(".js-testimonials-swiper");

    unbindAutoplayHold(root);
    unbindContentSwipe(root);
    unbindWheelNav(root);
    if (sliderEl?.swiper) sliderEl.swiper.destroy(true, true);
    resetMedia(mediaRoot, mediaItems);

    if (mediaRoot && mediaItems.length) {
      mediaRoot.classList.add("is-initialized");
      showMediaImmediately(mediaItems, 0);
    }

    if (!sliderEl) return;

    const slides = Array.from(sliderEl.querySelectorAll(".testimonials-text"));
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    const wrapper = sliderEl.querySelector(".testimonials__text-wrapper");
    if (wrapper) wrapper.classList.add("swiper-wrapper");

    const paginationEl = root.querySelector(".slider-pagination");
    const nextBtn = root.querySelector(".slider-nav-button--next");
    const prevBtn = root.querySelector(".slider-nav-button--prev");
    const hasAutoplay = sliderEl.getAttribute("data-autoplay") === "true";
    const pauseOnHover =
      sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
    const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 8000);
    const shouldLoop =
      sliderEl.getAttribute("data-loop") === "true" && slides.length > 1;

    const swiper = new Swiper(sliderEl, {
      loop: shouldLoop,
      loopAddBlankSlides: false,
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      effect: "fade",
      fadeEffect: { crossFade: true },
      watchSlideProgress: true,
      allowTouchMove: true,
      a11y: {
        scrollOnFocus: false,
      },
      autoplay: hasAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      navigation:
        nextBtn || prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
      on: {
        slideChange() {
          syncTextInert(this);
        },
        slideChangeTransitionStart() {
          if (!mediaItems.length) return;

          const prevIndex = this._testimonialsPrevIndex ?? this.realIndex;
          if (prevIndex === this.realIndex) return;

          revealMedia(
            mediaItems,
            this.realIndex,
            prevIndex,
            direction(prevIndex, this.realIndex, mediaItems.length, shouldLoop)
          );
          this._testimonialsPrevIndex = this.realIndex;
        },
      },
    });

    if (sliderEl.swiper) {
      syncTextInert(sliderEl.swiper);
      sliderEl.swiper._testimonialsPrevIndex = sliderEl.swiper.realIndex;
      if (mediaItems.length) {
        showMediaImmediately(mediaItems, sliderEl.swiper.realIndex);
      }
    }

    if (hasAutoplay) {
      root._testimonialsHold = holdSwiperAutoplay(swiper, root, {
        hoverTarget: pauseOnHover
          ? root.querySelector(".testimonials__content")
          : null,
      });
    }
    if (slides.length > 1) {
      bindContentSwipe(root, swiper);
      bindWheelNav(root, swiper);
    }
  };

  initSection(document.currentScript.parentElement);

  if (!window.__themeTestimonialsEvents) {
    window.__themeTestimonialsEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      destroySection(event.target);
    });
  }
})();
